import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import "./CancelButton.scss";
import useSession from "Utils/Hooks/useSession";
import useCancelRedirect from "Utils/Hooks/useCancelRedirect";
import { faro, LogLevel } from "@grafana/faro-react";
import { Box, Button } from "@pav/pav-products-design-system";
import { useMediaQuery, useTheme } from "@mui/material";
import CancelModal from "./CancelModal";
import { useVipAccountCache } from "context/VipAccountContext";

const CancelButton = ({ btnText, stage }) => {
  const vipApi = useVipApiFetcher();
  const history = useHistory();
  const { setVipAccount } = useVipAccountCache();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleClose = (event) => {
    if (event) event.preventDefault();
    setShowConfirmation(false);
  };
  const handleShow = () => setShowConfirmation(true);
  const { session, invalidateSession } = useSession();
  const url = useCancelRedirect() ?? session?.cancelRedirectUrl;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  async function onSuccess() {
    window.sessionStorage.setItem("IsRedirectOrCancel", true);
    window.sessionStorage.setItem("plaidlaunch", false);
    faro.api.pushLog(["Successful Cancel"], { level: LogLevel.INFO });
    if (url) {
      window.location.replace(url);
    } else {
      if (window.opener !== null && !window.opener.closed) {
        window.close();
      } else if (window.opener === null) {
        invalidateSession();
        setVipAccount(null);
        history.push("/logout");
      } else if (
        window.parent !== null &&
        window.parent.frames !== null &&
        window.parent.frames.length > 0
      ) {
        window.parent.postMessage("close", "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage("close", "*");
          } else if (document !== undefined) {
            document.postMessage("close", "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage("close", "*");
        } else {
          invalidateSession();
          setVipAccount(null);
          history.push("/logout");
        }
      }
    }
  }

  function onError(response) {
    history.push({
      pathname: "/error",
      state: {
        isError: true,
        showButton: true,
        title: "Request Failed. Please Try Again",
        message:
          response.patronErrorMessage ??
          "We are unable to complete this request. Please contact our Customer Service Team at 1-800-500-1973. Reference code E-30 so that we may better serve you.",
        allowRetry: false,
      },
    });
  }
  async function onSubmit(event) {
    event.preventDefault();
    faro.api.pushEvent(`User confirms to cancel ${btnText}`);
    vipApi
      .fetch("/api/usertracking/cancelflow", "POST", {
        transactionStage: stage,
        sessionId: JSON.parse(
          global.sessionStorage.getItem("vip-patron-session"),
        ).sessionId,
      })
      .then((response) => {
        if (response.ok) {
          onSuccess();
        } else {
          faro.api.pushError(new Error(`${btnText} Cancel Response Error`), {
            context: response,
          });
          if (response.status === 500) {
            console.error(response.statusText);
            history.push({
              pathname: "/error",
            });
          } else if (response.status === 401) {
            console.error(response.statusText);
            history.push({
              pathname: "/expired",
            });
          } else {
            response.json().then((data) => {
              console.error(data);
              onError(data);
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
        faro.api.pushError(new Error(`${btnText} Cancel Network Error`), {
          context: error,
        });
        history.push({
          pathname: "/error",
        });
      });
  }
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isMobile ? "center" : "flex-start",
          marginTop: "10px",
        }}
      >
        <Button
          buttonType="tertiary"
          className="text-center click-cancel"
          onClick={handleShow}
          fullWidth
        >
          Cancel {btnText}
        </Button>
      </Box>
      <CancelModal
        open={showConfirmation}
        handleClose={handleClose}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default CancelButton;
